<template>
  <div class="wrapper" :class="{'nav-open': $sidebar.showSidebar}">
    <side-bar :title="title" :logo="'/static/img/' + style + '_logo.png'">
      <mobile-menu></mobile-menu>
      <template slot="links" v-if="$store.getters.isNotFrontdesk">
        <sidebar-item :link="{name: 'Home', icon: 'fas fa-home', path: '/'}" :exact="true" />
        <sidebar-item :link="{name: 'Sammelbuchungen', icon: 'fa fa-layer-group', path: '/collective-bookings'}" />
        <sidebar-item :link="{name: 'Bestellungen', icon: 'fas fa-shopping-cart', path: '/orders'}" />
        <sidebar-item :link="{name: 'Lager', icon: 'fas fa-warehouse', path: '/warehouses'}" />
        <sidebar-item :link="{name: 'Standorte', icon: 'fas fa-warehouse', path: '/locations'}" />
        <sidebar-item :link="{name: 'Lagerbewegungen', icon: 'fas fa-exchange-alt', path: '/stock_rotations'}" />
        <sidebar-item :link="{name: 'Lieferanten', icon: 'fas fa-truck', path: '/suppliers'}" />
        <sidebar-item :link="{name: 'Produkte', icon: 'fas fa-boxes', path: '/products'}"
          v-if="$store.getters.isNotUser"
        />

        <sidebar-item :link="{name: 'Administratives', icon: 'fas fa-list-alt'}"
          v-if="$store.getters.isNotUser"
          >
          <sidebar-item :link="{name: 'Box Vewaltung', icon: 'fas fa-box-open', path: '/boxes'}"
            v-if="$store.getters.isNotUser"
          />
          <sidebar-item :link="{name: 'Etiketten', icon: 'fas fa-tags', path: '/labels'}"
            v-if="$store.state.activatedLabels.length > 1"
          />
          <sidebar-item :link="{name: 'Inventur', icon: 'fas fa-clipboard-check', path: '/inventory'}" />
          <sidebar-item :link="{name: 'Statistik', icon: 'fas fa-chart-line', path: '/stats'}"
            v-if="$store.getters.isAdmin"
          />

        </sidebar-item>

        <sidebar-item :link="{name: 'Stammdaten', icon: 'fas fa-list-alt'}"
          v-if="$store.getters.isNotUser"
        >
          <sidebar-item :link="{name: 'Allgemeines', icon: 'fas fa-cogs', path: '/settings'}" />
          <sidebar-item v-if="$store.getters.isAdmin" :link="{name: 'Benutzer', icon: 'fas fa-users', path: '/users'}" />
          <sidebar-item :link="{name: 'Einheiten', icon: 'fas fa-balance-scale', path: '/units'}" />
          <sidebar-item :link="{name: 'Gründe', icon: 'fas fa-clipboard-list', path: '/causes'}" />
          <sidebar-item :link="{name: 'Kostenstellen', icon: 'fas fa-cash-register', path: '/cost_centers'}" />
          <sidebar-item :link="{name: 'Produktkategorien', icon: 'fas fa-sitemap', path: '/product_categories'}" />
        </sidebar-item>
      </template>
      <template slot="links" v-if="$store.getters.isFrontdesk">
        <sidebar-item :link="{name: 'Home', icon: 'fas fa-home', path: '/'}" :exact="true" />
        <sidebar-item :link="{name: 'Lager', icon: 'fas fa-warehouse', path: '/warehouses'}" />
        <sidebar-item :link="{name: 'Lagerbewegungen', icon: 'fas fa-exchange-alt', path: '/stock_rotations'}" />
      </template>
    </side-bar>
    <div class="main-panel">
      <top-navbar></top-navbar>

      <dashboard-content @click.native="toggleSidebar">

      </dashboard-content>

      <content-footer></content-footer>
    </div>
  </div>
</template>

<script>
import TopNavbar from './TopNavbar.vue'
import ContentFooter from './ContentFooter.vue'
import DashboardContent from './Content.vue'
import MobileMenu from './Extra/MobileMenu.vue'
export default {
  components: {
    TopNavbar,
    ContentFooter,
    DashboardContent,
    MobileMenu
  },
  data () {
    return {
      title:  process.env.VUE_APP_SIDEBAR_TITLE ? process.env.VUE_APP_SIDEBAR_TITLE : 'Eder IT',
      style:  process.env.VUE_APP_STYLE ? process.env.VUE_APP_STYLE : 'ederit'
    }
  },
  methods: {
    toggleSidebar () {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false)
      }
    }
  }
}

</script>
